export function initializeSingleSlider() {
    const topSlider = document.querySelector('.top-level-slider');
    const bottomSlider = document.querySelector('.bottom-level-slider');

    if (!topSlider && !bottomSlider) return;

    if (topSlider) {
        new Swiper('.top-level-slider', {
            loop: true,
            slidesPerView: 4,
            spaceBetween: 20,
            speed: 5000,
            autoplay: {
                delay: 1,
                disableOnInteraction: false,
            },
            freeMode: true,
            freeModeMomentum: false,
            allowTouchMove: false,
            grabCursor: false,
        });
    }

    if (bottomSlider) {
        new Swiper('.bottom-level-slider', {
            loop: true,
            slidesPerView: 4,
            spaceBetween: 20,
            speed: 5000,
            autoplay: {
                delay: 1,
                disableOnInteraction: false,
                reverseDirection: true,
            },
            freeMode: true,
            freeModeMomentum: false,
            allowTouchMove: false,
            grabCursor: false,
        });
    }
}
